const PER_PAGE = 10;
const INITIAL_LOADING_PARAMS = { page: 1, per_page: PER_PAGE };

const getLoadingParams = (page) => {
  return { page, per_page: PER_PAGE };
};

export { PER_PAGE, INITIAL_LOADING_PARAMS, getLoadingParams };
